'use strict';
import React, {useState, useEffect} from 'react';
import { createRoot } from 'react-dom/client';

import MyLeaguesCard from './MyLeaguesCard';
import MyLeaguesFilters from './MyLeaguesFilters';
import myLeaguesFilters from "./MyLeaguesFilters";

class MyLeagues extends React.Component {
    constructor(props) {
        super(props);

        this.maxNameHeight = 0;

        this.state = JSON.parse(JSON.stringify(myLeagues));
        this.state.sports = this.getSport();

        this.clickedSport.bind(this);
    }

    leagueFilters = (element, sport, finished_leagues) => {
        //Check sport filter (if populated)
        if (sport && element.league.sport !== sport) {
            return false;
        }

        //Check the finished league filter (Finished league must be equal to status closed status)
        if(finished_leagues !== "all" && finished_leagues !== (element.league.status === "closed")) {
            return false;
        }

        //Passed
        return true;
    }

    clickedSport = (sport) => {
        //Check if clicked sport is a toggle
        if(this.state.active_sport === sport) {
            sport = "";
        }

        let leagues = [...myLeagues.leagues];
        leagues = leagues.filter((element) => this.leagueFilters(element, sport, this.state.show_finished_leagues));

        this.setState({
            active_sport: sport,
            leagues: leagues
        });
    }

    toggleFinishedLeagues = () => {
        const newStatus = Boolean(1 - this.state.show_finished_leagues);

        let leagues = [...myLeagues.leagues];
        leagues = leagues.filter((element) => this.leagueFilters(element, this.state.active_sport, newStatus));

        this.setState({
            show_finished_leagues: newStatus,
            leagues: leagues
        });
    }

    getSport = () => {
        const sports = [];
        myLeagues.leagues.forEach((value) => {
            if (sports.indexOf(value.league.sport) === -1) {
                sports.push(value.league.sport);
            }
        });
        return sports;
    }

    componentDidMount() {
        let leagues = [...myLeagues.leagues];
        leagues = leagues.filter((element) => this.leagueFilters(element, this.state.active_sport, this.state.show_finished_leagues));

        this.setLeagueNameHeight();

        this.setState({
            leagues: leagues,
        });
    }

    componentDidUpdate() {
        this.setLeagueNameHeight();
    }

    setLeagueNameHeight() {
        const that = this;

        setTimeout(function() {
            //Get the max height
            document.querySelectorAll(".card-container .card .font-semibold").forEach((element) => {
                if (element.offsetHeight > that.maxNameHeight) {
                    that.maxNameHeight = element.offsetHeight;
                }
            })

            //Set the max height
            document.querySelectorAll(".card-container .card .font-semibold").forEach((element) => {
                element.style.height = that.maxNameHeight + "px";
            });
        }, 100);
    }

    render() {
        const labels = this.state.labels;
        const sports = this.state.sports;
        const routes = this.state.routes;


        return (
            <React.StrictMode>
                <div className="container">
                    <h2 className="text-center">{labels.title}</h2>

                    {this.state.show_filters &&
                        <MyLeaguesFilters labels={labels} sports={sports}
                                          toggleFinishedLeagues={this.toggleFinishedLeagues} show_finished_leagues={this.state.show_finished_leagues}
                                          clickedSport={this.clickedSport} active_sport={this.state.active_sport}/>
                    }

                    <div className={"league-list row " + (!this.state.show_filters ? "justify-center" : "")}>
                        {this.state.leagues.map((league) => (
                            <MyLeaguesCard labels={labels} route={routes.league} league={league}/>
                        ))}
                    </div>

                    {this.state.show_see_all &&
                        <div className="text-center">
                            <a className="btn btn-primary" href={routes.all_leagues}>{labels.see_all}</a>
                        </div>
                    }
                </div>
            </React.StrictMode>
        );
    }
}

export default MyLeagues;

if (document.getElementById('my-leagues')) {
    createRoot(document.getElementById('my-leagues')).render(<MyLeagues/>);
}
